/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ComparedCarrierField {
  selfEnroll = 'selfEnroll',
  enrollmentEffortTier = 'enrollmentEffortTier',
  extraSteps = 'extraSteps',
  isPdfApplicationAvailable = 'isPdfApplicationAvailable',
  phoneNumber = 'phoneNumber',
  providerSearchUrl = 'providerSearchUrl',
  medicationSearchUrl = 'medicationSearchUrl',
  isDocumentsRequired = 'isDocumentsRequired',
  websiteUrl = 'websiteUrl',
  initialPayment = 'initialPayment',
  autoPay = 'autoPay',
  specialRequestsElectionSubmitted = 'specialRequestsElectionSubmitted',
  specialRequestsCarrierAppSent = 'specialRequestsCarrierAppSent',
  carrierRequestStatus = 'carrierRequestStatus',
  echoCode = 'echoCode',
  paymentMethod = 'paymentMethod',
}
